import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;

  a {
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #535862;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
    }
  }
`;

export const CardContent = styled.div`
  background: #fff;
  padding: 0;
`;

export const ShowMoreButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #535862;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
  &:active:not(:disabled) {
    opacity: 0.6;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: transparent;
    border: none !important;
  }
`;

// --- Table Cells ---
export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AssetLogo = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AssetInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
`;

export const ExecutionCell = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TotalCell = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => (props.$isPositive ? "#2D8C44" : "#C14A41")};
`;
